import React from 'react';
import { MuiTelInput } from 'mui-tel-input';

export default function RoundedTelInput({ value, onChange, defaultCountry = 'in', sx, ...props }) {
  return (
    <MuiTelInput
      fullWidth
      value={value}
      onChange={onChange}
      defaultCountry={defaultCountry}
      sx={{
        '& .MuiInputLabel-root': {
          color: 'var(--color-text-secondary)',
          fontSize: '14px',
          fontWeight: 500,
          '&.Mui-focused': {
            color: 'var(--color-primary)',
            backgroundColor: 'var(--color-bg-secondary)',
            padding: '0 8px',
          },
          '&.MuiInputLabel-shrink': {
            backgroundColor: 'var(--color-bg-secondary)',
            padding: '0 8px',
          },
        },
        '& .MuiOutlinedInput-root': {
          borderRadius: '12px',
          bgcolor: 'var(--color-bg)',
          border: '1px solid var(--color-border)',
          fontSize: '14px',
          fontWeight: 400,
          transition: 'all 0.2s ease',
          '& fieldset': {
            border: 'none',
          },
          '&:hover': {
            borderColor: 'var(--color-primary)',
          },
          '&.Mui-focused': {
            bgcolor: 'var(--color-bg-secondary)',
            borderColor: 'var(--color-primary)',
            boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)',
          },
        },
        '& .MuiInputBase-input': {
          color: 'var(--color-text-primary)',
          fontSize: '14px',
          fontWeight: 400,
          py: 1.5,
        },
        ...sx,
      }}
      {...props}
    />
  );
}
